"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRfpActivityDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_rfp_detail_entity_1 = require("./opportunity-rfp-detail.entity");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let OpportunityRfpActivityDocumentMap = class OpportunityRfpActivityDocumentMap {
};
exports.OpportunityRfpActivityDocumentMap = OpportunityRfpActivityDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpActivityDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_map_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpActivityDocumentMap.prototype, "opportunityActivityMapId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "rfp_detail_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpActivityDocumentMap.prototype, "rfpDetailId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpActivityDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: false }) // Add the new column
    ,
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpActivityDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_activity_map_entity_1.OpportunityActivityMap, (activityMap) => activityMap.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_activity_map_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityRfpActivityDocumentMap.prototype, "opportunityActivityMap", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_rfp_detail_entity_1.OpportunityRfpDetail, (rfpDetail) => rfpDetail.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "rfp_detail_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityRfpActivityDocumentMap.prototype, "rfpDetail", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileUpload) => fileUpload.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityRfpActivityDocumentMap.prototype, "document", void 0);
exports.OpportunityRfpActivityDocumentMap = OpportunityRfpActivityDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_rfp_activity_document_map")
], OpportunityRfpActivityDocumentMap);
